/**
 * Docum API
 * Docum API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DocumentoInteresModel } from '../model/documentoInteresModel';
// @ts-ignore
import { DocumentoInteresRoleModel } from '../model/documentoInteresRoleModel';
// @ts-ignore
import { PageDocumentoInteresModel } from '../model/pageDocumentoInteresModel';
// @ts-ignore
import { Pageable } from '../model/pageable';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable()
export class DocumentoInteresControllerService {

    protected basePath = 'https://devenvanet.envalora.es';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param id
     * @param nombre
     * @param roles
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public actualizarDocumentoInteres(id: number, nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DocumentoInteresModel>;
    public actualizarDocumentoInteres(id: number, nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DocumentoInteresModel>>;
    public actualizarDocumentoInteres(id: number, nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DocumentoInteresModel>>;
    public actualizarDocumentoInteres(id: number, nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling actualizarDocumentoInteres.');
        }
        if (nombre === null || nombre === undefined) {
            throw new Error('Required parameter nombre was null or undefined when calling actualizarDocumentoInteres.');
        }
        if (roles === null || roles === undefined) {
            throw new Error('Required parameter roles was null or undefined when calling actualizarDocumentoInteres.');
        }
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling actualizarDocumentoInteres.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (nombre !== undefined && nombre !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nombre, 'nombre');
        }
        if (roles) {
            roles.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roles');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<DocumentoInteresModel>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param identificador
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public descargarDocumentoInteres(identificador: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<string>;
    public descargarDocumentoInteres(identificador: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpResponse<string>>;
    public descargarDocumentoInteres(identificador: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpEvent<string>>;
    public descargarDocumentoInteres(identificador: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<any> {
        if (identificador === null || identificador === undefined) {
            throw new Error('Required parameter identificador was null or undefined when calling descargarDocumentoInteres.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (identificador !== undefined && identificador !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>identificador, 'identificador');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/download`;
        return this.httpClient.request<string>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eliminarDocumentoInteres(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<DocumentoInteresModel>;
    public eliminarDocumentoInteres(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpResponse<DocumentoInteresModel>>;
    public eliminarDocumentoInteres(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpEvent<DocumentoInteresModel>>;
    public eliminarDocumentoInteres(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling eliminarDocumentoInteres.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<DocumentoInteresModel>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param pageable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAll1(pageable: Pageable, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PageDocumentoInteresModel>;
    public findAll1(pageable: Pageable, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PageDocumentoInteresModel>>;
    public findAll1(pageable: Pageable, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PageDocumentoInteresModel>>;
    public findAll1(pageable: Pageable, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling findAll1.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (pageable !== undefined && pageable !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageable, 'pageable');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/listar-todos`;
        return this.httpClient.request<PageDocumentoInteresModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllByUser(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DocumentoInteresModel>>;
    public findAllByUser(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DocumentoInteresModel>>>;
    public findAllByUser(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DocumentoInteresModel>>>;
    public findAllByUser(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes`;
        return this.httpClient.request<Array<DocumentoInteresModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllRoles(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DocumentoInteresRoleModel>>;
    public findAllRoles(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DocumentoInteresRoleModel>>>;
    public findAllRoles(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DocumentoInteresRoleModel>>>;
    public findAllRoles(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling findAllRoles.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/roles`;
        return this.httpClient.request<Array<DocumentoInteresRoleModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param identificador 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findByIdentificador(identificador: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DocumentoInteresModel>;
    public findByIdentificador(identificador: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DocumentoInteresModel>>;
    public findByIdentificador(identificador: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DocumentoInteresModel>>;
    public findByIdentificador(identificador: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (identificador === null || identificador === undefined) {
            throw new Error('Required parameter identificador was null or undefined when calling findByIdentificador.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (identificador !== undefined && identificador !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>identificador, 'identificador');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/buscar`;
        return this.httpClient.request<DocumentoInteresModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param nombre
     * @param roles
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subirDocumentoInteres(nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DocumentoInteresModel>;
    public subirDocumentoInteres(nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DocumentoInteresModel>>;
    public subirDocumentoInteres(nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DocumentoInteresModel>>;
    public subirDocumentoInteres(nombre: string, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, file: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (nombre === null || nombre === undefined) {
            throw new Error('Required parameter nombre was null or undefined when calling subirDocumentoInteres.');
        }
        if (roles === null || roles === undefined) {
            throw new Error('Required parameter roles was null or undefined when calling subirDocumentoInteres.');
        }
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling subirDocumentoInteres.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (nombre !== undefined && nombre !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nombre, 'nombre');
        }
        if (roles) {
            roles.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roles');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/docum/documentos-interes/upload`;
        return this.httpClient.request<DocumentoInteresModel>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
